
<div class="d-flex justify-content-between l_rwd">
  <app-label-text class="mb-0" :title="title"></app-label-text>
  <app-normal-text class="mr-3" :text="text" :ellipsis="ellipsis"></app-normal-text>
</div>
